import "@/styles/main.scss";

import { createApp } from "vue";

import { registerPlugins } from "@/shared/plugins";

import App from "./App.vue";

const app = createApp(App);

registerPlugins(app);

app.mount("#app");
